export default "__VITE_ASSET__f88d84ed__"